var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLegal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 14.5,
    fill: "#F5F6F8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 14.5,
    stroke: "#F5F6F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9644 15.3125L19.9644 10.3125C19.9203 10.2024 19.8386 10.1115 19.7337 10.0561C19.6288 10.0006 19.5077 9.98432 19.3919 10.01L15.5 10.875V9.5C15.5 9.36739 15.4473 9.24021 15.3536 9.14645C15.2598 9.05268 15.1326 9 15 9C14.8674 9 14.7402 9.05268 14.6465 9.14645C14.5527 9.24021 14.5 9.36739 14.5 9.5V11.0988L10.3913 12.0119C10.312 12.0294 10.2383 12.0659 10.1763 12.1183C10.1144 12.1706 10.0661 12.2373 10.0356 12.3125V12.3162L8.03563 17.3125C8.01171 17.3721 7.99961 17.4358 8.00001 17.5C8.00001 18.9569 9.53376 19.5 10.5 19.5C11.4663 19.5 13 18.9569 13 17.5C13.0004 17.4358 12.9883 17.3721 12.9644 17.3125L11.1825 12.8606L14.5 12.125V20H13.5C13.3674 20 13.2402 20.0527 13.1465 20.1464C13.0527 20.2402 13 20.3674 13 20.5C13 20.6326 13.0527 20.7598 13.1465 20.8536C13.2402 20.9473 13.3674 21 13.5 21H16.5C16.6326 21 16.7598 20.9473 16.8536 20.8536C16.9473 20.7598 17 20.6326 17 20.5C17 20.3674 16.9473 20.2402 16.8536 20.1464C16.7598 20.0527 16.6326 20 16.5 20H15.5V11.9012L18.6875 11.1937L17.0356 15.3125C17.0117 15.3721 16.9996 15.4358 17 15.5C17 16.9569 18.5338 17.5 19.5 17.5C20.4663 17.5 22 16.9569 22 15.5C22.0004 15.4358 21.9883 15.3721 21.9644 15.3125ZM10.5 18.5C10.0294 18.5 9.07751 18.2744 9.00438 17.585L10.5 13.8463L11.9956 17.585C11.9225 18.2744 10.9706 18.5 10.5 18.5ZM19.5 16.5C19.0294 16.5 18.0775 16.2744 18.0044 15.585L19.5 11.8463L20.9956 15.585C20.9225 16.2744 19.9706 16.5 19.5 16.5Z",
    fill: "#434343"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegal);
export default __webpack_public_path__ + "static/media/Legal.b371abfa2338d267e470f78ce4dbfba2.svg";
export { ForwardRef as ReactComponent };